import { useCallback } from 'react';
import { useSearchParams } from 'react-router-dom';

export function useSetSearchParams() {
    const [searchParams, setSearchParams] = useSearchParams();

    const setParams = useCallback(
        (obj: Record<string, string>) => {
            Object.entries(obj).forEach(([key, value]) => searchParams.set(key, value));
            setSearchParams(searchParams);
        },
        [searchParams, setSearchParams]
    );

    return setParams;
}
